<!-- 课程管理 添加 -->
<template>
  <div>
    <div class="form_box__group__item">
      <div class="form_box__group__item__title">上课地址:</div>
      <div class="form_box__group__item__content ml-10">
        <el-input v-model="location" placeholder="例如：上海市静安区南京西路595号上海棋院" style="width:600px;"></el-input>
        <!-- <el-button type="primary" class="ml-2" @click="searchLocation">检查位置信息</el-button> -->
      </div>
      <div class="form_box__group__item__tool"></div>
    </div>
    <div class="form_box__group__item">
      <div class="w-60 ml-2">
        <el-alert title="请确认地图中“蓝色角标”的位置，蓝色角标可以拖拽" type="warning"></el-alert>
      </div>
    </div>

    <div class="map__container">
      <div id="container"></div>
      <div class="dimension">
        <div>经度:{{ lng }}</div>
        <div>纬度:{{ lat }}</div>
        <!-- {{mapAddress}} -->
      </div>
    </div>
  </div>
</template>


<script>

export default {
  name: "locationSelectorBaidu",
  data() {
    return {
      hasInitScript: false,
      location : "",
      lat : 0.0,
      lng : 0.0,
      mapGl: null,
      myGeo : null,
      mapAddress : "",
      mapaddresses : [],
      mapVal : [],
      loading : false,
      hasInit : false,
      point : null

    };
  },
  methods:{
    init(){
      this.location = "";
      this.initMap();
    },

    initMap() {
      console.log("初始化百度地图")
      // 初始化 map

      let map;
      if(!this.hasInit){
        map = new BMapGL.Map("container");
        this.mapGl = map;
        this.point = new BMapGL.Point(121.478497, 31.239663);    // 体育大楼

      }
      else {
        map = this.mapGl;
      }

      map.centerAndZoom(this.point, 15);
      map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放

                      // 将标注添加到地图  
    
      this.initMarker(121.478497,31.239663);

      console.log("初始化百度地图 结束")
    },

    // 初始化标记符号
    initMarker(lng,lat){    
      this.mapGl.clearOverlays();

      let p = new BMapGL.Point(lng, lat); 
      let po = {
        enableDragging : true
      }

      var marker = new BMapGL.Marker(p,po);        // 创建标注   
      marker.addEventListener("dragging",(e)=>{
        let latlng = e.latLng;
        // console.log("e",e)
        this.lat = latlng.lat;
        this.lng = latlng.lng;

        let point = new BMapGL.Point(this.lng, this.lat); 
        this.mapGl.setCenter(point)
      })

      this.mapGl.addOverlay(marker);
      this.mapGl.centerAndZoom(p, 15);
    },

    showInfoM(e) {
      this.lat = e.lnglat.lat;
      this.lng = e.lnglat.lng;
    },

    handleSelectLocation(item) {
      this.lat = item.lat;
      this.lng = item.lng;
      this.updateBMap(this.lng, this.lat);
    },

    antiShake(fun, tim) {
      let timeout = null;
      let _this = this;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fun.call(_this, arguments);
        }, tim);
      };
    },

    updateBMap(lng, lat) {
      this.initMarker(lng,lat);
    },

    /* 根据地址解析位置信息 */
    searchLocation(suc, fail) {
      let _this = this;
      // 创建地址解析器实例

      let loc = this.location;
      // console.log("loc : ",loc)

      let geo;

      if(!this.myGeo){      
        geo = new BMapGL.Geocoder();
        this.myGeo = geo;
      }
      else {
        geo = this.myGeo;
      }
      
      geo.getPoint(loc, function(point){
          if(point){
              // console.log("geo",point)
              _this.lat = point.lat
              _this.lng = point.lng
              _this.initMarker(_this.lng,_this.lat)

          }else{
              // alert('您选择的地址没有解析到结果！');
          }
      }, '上海市')
    }

  },

  watch:{
    location(oldVal,newVal){
      this.searchLocation(()=>{
      },
      ()=>{
      });


      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData);
    },

    lat(){
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData);
    },

    lng(){
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData);
    }
  },

  created() {

  },
};








// @ is an alias to /src
// declare var BMapGL: any;

</script>

<style scoped lang="scss">
.map__container {
  margin-left: 10px;
  width: 600px;
  height: 400px;
  position: relative;
  .dimension {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(130%);
  }
}
.input__location {
  width: 400px;
}

#container {
  width: 100%;
  height: 100%;
}
</style>

